import Vue from 'vue'
import Router from 'vue-router'
import Personal from './personal'

Vue.use(Router)

const RouteList = [{
  path: '/',
  component: resolve => require(['@/views/layout/App.vue'], resolve),
  meta: {
    title: '首页',
    keepAlive: false
  },
  children: [{
    path: '/',
    name: 'Dashboard',
    meta: {
      title: '首页',
      keepAlive: true
    },
    component: resolve => require(['@/views/home/Index.vue'], resolve)
  },

  // 个人资料
  Personal.index,
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '首页',
      keepAlive: false
    },
    component: resolve => require(['@/views/home/Index.vue'], resolve)
  },
  {
    path: '/management',
    name: 'management',
    meta: {
      title: '门店管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/management.vue'], resolve)
  },
  {
    path: '/store_edit',
    name: 'store_edit',
    meta: {
      title: '门店信息',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/com/store_edit.vue'], resolve)
  },
  // {
  //   path: '/store_trim',
  //   name: 'store_trim',
  //   meta: {
  //     title: '门店配置',
  //     keepAlive: false
  //   },
  //   component: resolve => require(['@/views/store/com/store_trim.vue'], resolve)
  // },
  {
    path: '/write',
    name: 'write',
    meta: {
      title: '门店管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/write.vue'], resolve)
  },
  {
    path: '/goods',
    name: 'goods',
    meta: {
      title: '商品管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/goods.vue'], resolve)
  },
  {
    path: '/commentList',
    name: 'commentList',
    meta: {
      title: '评论管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/comment_list.vue'], resolve)
  },
  {
    path: '/edit_goods',
    name: 'edit_goods',
    meta: {
      title: '编辑商品',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/edit_goods.vue'], resolve)
  },

  {
    path: '/writeOff',
    name: 'writeOff',
    meta: {
      title: '核销',
      keepAlive: false
    },
    component: resolve => require(['@/views/write/writeOff.vue'], resolve)
  },
  {
    path: '/writeSuccess',
    name: 'writeSuccess',
    meta: {
      title: '核销成功',
      keepAlive: false
    },
    component: resolve => require(['@/views/write/success.vue'], resolve)
  },
  {
    path: '/record',
    name: 'record',
    meta: {
      title: '核销记录',
      keepAlive: false
    },
    component: resolve => require(['@/views/write/record.vue'], resolve)
  },
  {
    path: '/account',
    name: 'account',
    meta: {
      title: '资金明细',
      keepAlive: false
    },
    component: resolve => require(['@/views/finance/account.vue'], resolve)
  },
  {
    path: '/water_list',
    name: 'water_list',
    meta: {
      title: '资金流水',
      keepAlive: false
    },
    component: resolve => require(['@/views/finance/com/water_list.vue'], resolve)
  },
  {
    path: '/reflect_list',
    name: 'reflect_list',
    meta: {
      title: '提现记录',
      keepAlive: false
    },
    component: resolve => require(['@/views/finance/com/reflect_list.vue'], resolve)
  },
  {
    path: '/user_withdrawal',
    name: 'user_withdrawal',
    meta: {
      title: '用户提现',
      keepAlive: false
    },
    component: resolve => require(['@/views/finance/user_withdrawal.vue'], resolve)
  },
  {
    path: '/merchant',
    name: 'merchant',
    meta: {
      title: '收款商户管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/finance/merchant.vue'], resolve)
  },
  {
    path: '/logistics',
    name: 'logistics',
    meta: {
      title: '物流模版',
      keepAlive: false
    },
    component: resolve => require(['@/views/template/logistics.vue'], resolve)
  },
  {
    path: '/logistics_edit',
    name: 'logistics_edit',
    meta: {
      title: '保存物流模版',
      keepAlive: false
    },
    component: resolve => require(['@/views/template/com/logistics_edit.vue'], resolve)
  },
  {
    path: '/cardLibrary',
    name: 'cardLibrary',
    meta: {
      title: '卡劵模版库',
      keepAlive: false
    },
    component: resolve => require(['@/views/cardLibrary/cardLibrary.vue'], resolve)
  },
  {
    path: '/cardLibrary_list',
    name: 'cardLibrary_list',
    meta: {
      title: '卡卷列表',
      keepAlive: false
    },
    component: resolve => require(['@/views/cardLibrary/cardLibrary_list.vue'], resolve)
  },
  {
    path: '/local_order',
    name: 'orderLocal',
    meta: {
      title: '核销订单',
      keepAlive: false,
      activeMenu: '/local_order'
    },
    component: resolve => require(['@/views/order/local_order.vue'], resolve),
  },
  {
    path: '/blindBox_order',
    name: 'blindBox_order',
    meta: {
      title: '福袋订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/blindBox_order.vue'], resolve),
  },
  {
    path: '/goods_order',
    name: 'goodsOrder',
    meta: {
      title: '电商订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/goods_order.vue'], resolve),
  },
  {
    path: '/eCard_order',
    name: 'eCardOrder',
    meta: {
      title: '卡劵订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/eCard_order.vue'], resolve),
  },
  {
    path: '/learnVideo_order',
    name: 'learnVideoOrder',
    meta: {
      title: '视频订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/learnVideo_order.vue'], resolve),
  },
  // 订单管理子页面
  {
    path: '/orderdetails',
    name: 'orderdetails',
    meta: {
      title: '编辑商品',
      keepAlive: false
    },

    component: resolve => require(['@/views/order/orderdetails.vue'], resolve)
  },
  {
    path: '/shipnow',
    name: 'shipnow',
    meta: {
      title: '订单详情',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/shipnow.vue'], resolve)
  },
  {
    path: '/bulkshipment',
    name: 'bulkshipment',
    meta: {
      title: '订单详情',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/bulkshipment.vue'], resolve)
  },

  {
    path: '/orderExamine',
    name: 'orderExamine',
    meta: {
      title: '申请退款审核',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/local_examine.vue'], resolve)
  },
  // 订单导出路由
  // {
  //   path: '/orderexport',
  //   name: 'orderexport',
  //   meta: {
  //     title: '订单导出',
  //     keepAlive: false
  //   },
  //   component: resolve => require(['@/views/order/local_orderexport.vue'], resolve)
  // },
  // 批量发货
  {
    path: '/logisticsuploadfile',
    name: 'logisticsuploadfile',
    meta: {
      title: '批量发货',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/local_logisticsuploadfile.vue'], resolve)
  },
  {
    path: '/notice',
    name: 'notice',
    meta: {
      title: '通知管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/home/notice.vue'], resolve)
  },
  {
    path: '/activity',
    name: 'activity',
    meta: {
      title: '活动中心',
      keepAlive: false
    },
    component: resolve => require(['@/views/activity/activity.vue'], resolve)
  },
  {
    path: '/activity_list',
    name: 'activity_list',
    meta: {
      title: '活动列表',
      keepAlive: false
    },
    component: resolve => require(['@/views/activity/activity_list.vue'], resolve)
  },
  {
    path: '/voucher',
    name: 'voucher',
    meta: {
      title: '代金券',
      keepAlive: false
    },
    component: resolve => require(['@/views/voucher/voucher.vue'], resolve)
  },
  {
    path: '/voucher_examine',
    name: 'voucher_examine',
    meta: {
      title: '代金券审核',
      keepAlive: false
    },
    component: resolve => require(['@/views/voucher/voucher_examine.vue'], resolve)
  },
  {
    path: '/shop_keeper',
    name: 'shop_keeper',
    meta: {
      title: '门店管理员',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/shop_keeper.vue'], resolve)
  },
  {
    path: '/business_edit',
    name: 'business_edit',
    meta: {
      title: '商家信息',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/com/business_edit.vue'], resolve),
  },
  {
    path: '/inSettlement_list',
    name: 'inSettlement_list',
    meta: {
      title: '结算中',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/inSettlement_list.vue'], resolve),
  },
  {
    path: '/takeOut_template',
    name: 'takeOut_template',
    meta: {
      title: '外送模版',
      keepAlive: false
    },
    component: resolve => require(['@/views/template/takeOut_template.vue'], resolve),
  },
  {
    path: '/takeOut_edit',
    name: 'takeOut_edit',
    meta: {
      title: '外送模版',
      keepAlive: false
    },
    component: resolve => require(['@/views/template/com/takeOut_edit.vue'], resolve),
  },
  {
    path: '/takeout_set',
    name: 'takeout_set',
    meta: {
      title: '外送菜单',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/takeout_set.vue'], resolve),
  },
  {
    path: '/shopMenu',
    name: 'shopMenu',
    meta: {
      title: '外送菜单',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/shopMenu.vue'], resolve),
  },
  {
    path: '/wsDetail',
    name: 'wsDetail',
    meta: {
      title: '订单详情',
      keepAlive: false,
      activeMenu: '/local_order'
    },
    component: resolve => require(['@/views/order/com/wsDetail.vue'], resolve),
  },
  {
    path: '/shop_account',
    name: 'shop_account',
    meta: {
      title: '充值明细',
      keepAlive: false,
      // activeMenu:'/takeout_set'
    },
    component: resolve => require(['@/views/store/shop_account.vue'], resolve),
  },
  {
    path: '/videoManagement',
    name: 'videoManagement',
    meta: {
      title: '视频号视频',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/videoManagement.vue'], resolve),
  },
  {
    path: '/video',
    name: 'video',
    meta: {
      title: '视频管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/video/video.vue'], resolve),
  },
  {
    path: '/edit_video',
    name: 'edit_video',
    meta: {
      title: '短视频',
      keepAlive: false
    },
    component: resolve => require(['@/views/video/com/edit_video.vue'], resolve),
  },
  {
    path: '/video_statistics',
    name: 'video_statistics',
    meta: {
      title: '视频统计',
      keepAlive: false
    },
    component: resolve => require(['@/views/video/video_statistics.vue'], resolve),
  },
  {
    path: '/comment',
    name: 'comment',
    meta: {
      title: '评论管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/video/com/comment.vue'], resolve),
  },
  {
    path: '/material',
    name: 'material',
    meta: {
      title: '碰一碰素材',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/material.vue'], resolve),
  },
  {
    path: '/touch',
    name: 'touch',
    meta: {
      title: '碰一碰管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/touch.vue'], resolve),
  },
  {
    path: '/touchIt',
    name: 'touchIt',
    meta: {
      title: '碰一碰配置',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/touchIt.vue'], resolve),
  },
  {
    path: '/task',
    name: 'task',
    meta: {
      title: '任务管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/task.vue'], resolve),
  },
  {
    path: '/aiPrice',
    name: 'aiPrice',
    meta: {
      title: 'AI点数充值',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/aiPrice.vue'], resolve),
  },
  {
    path: '/share',
    name: 'share',
    meta: {
      title: '抖音分享',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/share.vue'], resolve),
  },
  {
    path: '/coupon',
    name: 'coupon',
    meta: {
      title: '优惠券管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/coupon/coupon.vue'], resolve)
  },
  {
    path: '/couponFf',
    name: 'couponFf',
    meta: {
      title: '优惠券',
      keepAlive: false
    },
    component: resolve => require(['@/views/coupon/coupon_ff.vue'], resolve)
  },
  {
    path: '/coupon_records',
    name: 'coupon_records',
    meta: {
      title: '券码记录',
      keepAlive: false
    },
    component: resolve => require(['@/views/coupon/coupon_records.vue'], resolve)
  },
  {
    path: '/addCoupon',
    name: 'addCoupon',
    meta: {
      title: '新建劵',
      keepAlive: false
    },
    component: resolve => require(['@/views/coupon/addCoupon.vue'], resolve)
  },
  {
    path: '/coupon_detail',
    name: 'coupon_detail',
    meta: {
      title: '优惠劵详情',
      keepAlive: false
    },
    component: resolve => require(['@/views/coupon/coupon_detail.vue'], resolve)
  },
  {
    path: '/tutorial',
    name: 'tutorial',
    meta: {
      title: '教程',
      keepAlive: false
    },
    component: resolve => require(['@/views/home/tutorial.vue'], resolve),
  },
  {
    path: '/tutorial_detail',
    name: 'tutorial_detail',
    meta: {
      title: '教程详情',
      keepAlive: false
    },
    component: resolve => require(['@/views/home/tutorial_detail.vue'], resolve),
  },
  {
    path: '/user_list',
    name: 'user_list',
    meta: {
      title: '用户列表',
      keepAlive: false
    },
    component: resolve => require(['@/views/user/user_list.vue'], resolve),
  },
  {
    path: '/trim',
    name: 'trim',
    meta: {
      title: '店铺配置',
      keepAlive: false
    },
    component: resolve => require(['@/views/user/trim.vue'], resolve),
  },
  {
    path: '/marke',
    name: 'marke',
    meta: {
      title: '互动营销',
      keepAlive: false
    },
    component: resolve => require(['@/views/user/marke.vue'], resolve),
  },
  {
    path: '/promotion',
    name: 'promotion',
    meta: {
      title: '分销推广',
      keepAlive: false
    },
    component: resolve => require(['@/views/promotion/promotion.vue'], resolve),
  },
  {
    path: '/touch_worker',
    name: 'touch_worker',
    meta: {
      title: '员工分享管理',
      keepAlive: false
    },
    component: resolve => require(['@/views/store/touch_worker.vue'], resolve),
  },
  {
    path: '/stationOrder',
    name: 'stationOrder',
    meta: {
      title: '分销订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/order/stationOrder.vue'], resolve),
  },
  {
    path: '/goodsCount',
    name: 'goodsCount',
    meta: {
      title: '分销订单',
      keepAlive: false
    },
    component: resolve => require(['@/views/user/goodsCount.vue'], resolve),
  },
  {
    path: '/jhtask',
    name: 'jhtask',
    meta: {
      title: '推广任务',
      keepAlive: false
    },
    component: resolve => require(['@/views/task/jhtask.vue'], resolve),
  },
  {
    path: 'newJhtask',
    name: 'newJhtask',
    meta: {
      title: '新建任务',
      keepAlive: false
    },
    component: resolve => require(['@/views/task/newJhtask.vue'], resolve),
  },
  {
    path: '/giftPackage',
    name: 'giftPackage',
    meta: {
      title: '权益礼包',
      keepAlive: false
    },
    component: resolve => require(['@/views/task/giftPackage.vue'], resolve),
  },
  {
    path: '/taskRecord',
    name: 'taskRecord',
    meta: {
      title: '任务记录',
      keepAlive: false
    },
    component: resolve => require(['@/views/task/taskRecord.vue'], resolve),
  },
  {
    path: '/statistics',
    name: 'statistics',
    meta: {
      title: '任务统计',
      keepAlive: false
    },
    component: resolve => require(['@/views/task/statistics.vue'], resolve),
  },
  {
    path: '/matrixAccount',
    name: 'matrixAccount',
    meta: {
      title: '矩阵账号',
      keepAlive: false
    },
    component: resolve => require(['@/views/task/matrixAccount.vue'], resolve),
  },
  {
    path: '/task_account',
    name: 'task_account',
    meta: {
      title: '账户与统计',
      keepAlive: false
    },
    component: resolve => require(['@/views/task/task_account.vue'], resolve),
  },
  {
    path: '/activityRecord',
    name: 'activityRecord',
    meta: {
      title: '领取记录',
      keepAlive: false
    },
    component: resolve => require(['@/views/goods/activityRecord.vue'], resolve),
  },
  {
    path: '/landPage',
    name: 'landPage',
    meta: {
      title: '落地页',
      keepAlive: false
    },
    component: resolve => require(['@/views/user/landPage.vue'], resolve),
  },

  {
        path: '/index',
        name: 'index',
        meta: {
            title: '首页概览',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/index.vue'], resolve),
    },
    {
        path: '/myMiniPrograms',
        name: 'myMiniPrograms',
        meta: {
            title: '我的小程序',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/myMiniPrograms.vue'], resolve),
    },
    {
        path: '/authMiniPrograms',
        name: 'authMiniPrograms',
        meta: {
            title: '我的小程序',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/authMiniPrograms.vue'], resolve),
    },
    {
        path: '/templates',
        name: 'templates',
        meta: {
            title: '模板选择',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/templates.vue'], resolve),
    },
    {
        path: '/registration',
        name: 'registration',
        meta: {
            title: '小程序注册',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/registration.vue'], resolve),
    },
    {
        path: '/saasCertification',
        name: 'saasCertification',
        meta: {
            title: '小程序注册',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/certification.vue'], resolve),
    },
    {
        path: '/publish',
        name: 'publish',
        meta: {
            title: '发布管理',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/publish.vue'], resolve),
    },
    {
        path: '/checklist',
        name: 'checklist',
        meta: {
            title: '检查清单',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/checklist.vue'], resolve),
    },
    {
        path: '/certificationAndFiling',
        name: 'certificationAndFiling',
        meta: {
            title: '认证及备案',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/com/certificationAndFiling.vue'], resolve),
    },
    {
        path: '/illegalRecords',
        name: 'illegalRecords',
        meta: {
            title: '违规处罚',
            keepAlive: true
        },
        component: resolve => require(['@/views/newSaas/illegalRecords.vue'], resolve),
    },
    {
        path: '/basicInformation',
        name: 'basicInformation',
        meta: {
            title: '基本信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/newSaas/basicInformation.vue'], resolve),
    },
    {
        path: '/message_app',
        name: 'message_app',
        meta: {
            title: '订阅消息',
            keepAlive: false
        },
        component: resolve => require(['@/views/newSaas/message_app.vue'], resolve),
    },
    {
        path: '/message',
        name: 'message',
        meta: {
            title: '订阅消息',
            keepAlive: false
        },
        component: resolve => require(['@/views/newSaas/message.vue'], resolve),
    },
    {
        path: '/app_message',
        name: 'app_message',
        meta: {
            title: '订阅消息',
            keepAlive: false
        },
        component: resolve => require(['@/views/newSaas/app_message.vue'], resolve),
    },
    // {
    //     path: '/miniProgram',
    //     name: 'miniProgram',
    //     meta: {
    //         title: '微信小程序',
    //         keepAlive: true
    //     },
    //     component: resolve => require(['@/views/saas/miniProgram.vue'], resolve),
    // },
    // {
    //     path: '/miniProgram_register',
    //     name: 'miniProgram_register',
    //     meta: {
    //         title: '微信小程序注册',
    //         keepAlive: false
    //     },
    //     component: resolve => require(['@/views/saas/miniProgram_register.vue'], resolve),
    // },
    // {
    //     path: '/quick_registr',
    //     name: 'quick_registr',
    //     meta: {
    //         title: '快速创建小程序',
    //         keepAlive: false
    //     },
    //     component: resolve => require(['@/views/saas/quick_registr.vue'], resolve),
    // },
    // {
    //     path: '/certification',
    //     name: 'certification',
    //     meta: {
    //         title: '实名认证',
    //         keepAlive: false
    //     },
    //     component: resolve => require(['@/views/saas/certification.vue'], resolve),
    // },
    // {
    //     path: '/basicInformation',
    //     name: 'basicInformation',
    //     meta: {
    //         title: '基本信息',
    //         keepAlive: false
    //     },
    //     component: resolve => require(['@/views/saas/basicInformation.vue'], resolve),
    // },
    // {
    //     path: '/developmentSettings',
    //     name: 'developmentSettings',
    //     meta: {
    //         title: '开发设置',
    //         keepAlive: false
    //     },
    //     component: resolve => require(['@/views/saas/developmentSettings.vue'], resolve),
    // },
    {
        path: '/skin',
        name: 'skin',
        meta: {
            title: 'AI测肤配置',
            keepAlive: false
        },
        component: resolve => require(['@/views/store/skin.vue'], resolve),
    },
    {
        path: '/timeConfig',
        name: 'timeConfig',
        meta: {
            title: '预约时间配置',
            keepAlive: false
        },
        component: resolve => require(['@/views/store/timeConfig.vue'], resolve),
    },
    {
        path: '/home_banner',
        name: 'home_banner',
        meta: {
            title: 'banner管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/goods/home_banner.vue'], resolve),
    },
    {
        path: '/goods_class',
        name: 'goods_class',
        meta: {
            title: '商品分类',
            keepAlive: false
        },
        component: resolve => require(['@/views/goods/goods_class.vue'], resolve),
    },
    {
        path: '/appointment',
        name: 'appointment',
        meta: {
            title: '预约申请',
            keepAlive: false
        },
        component: resolve => require(['@/views/store/appointment.vue'], resolve),
    },
    {
        path: '/theme',
        name: 'theme',
        meta: {
            title: '店铺装修',
            keepAlive: false
        },
        component: resolve => require(['@/views/newSaas/theme.vue'], resolve),
    },
    {
        path: '/configApp',
        name: 'configApp',
        meta: {
            title: '配置模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/newSaas/configApp.vue'], resolve),
    },
    {
        path: '/saas_video',
        name: 'saas_video',
        meta: {
            title: '视频号',
            keepAlive: false
        },
        component: resolve => require(['@/views/newSaas/saas_video.vue'], resolve),
    },
    {
        path: '/poi_visit',
        name: 'poi_visit',
        meta: {
            title: 'Poi统计',
            keepAlive: false
        },
        component: resolve => require(['@/views/newSaas/poi_visit.vue'], resolve),
    },
    {
        path: '/user_tx',
        name: 'user_tx',
        meta: {
            title: '用户提现',
            keepAlive: false
        },
        component: resolve => require(['@/views/finance/user_tx.vue'], resolve),
    },
    {
        path: '/zc_authorization',
        name: 'zc_authorization',
        meta: {
            title: '注册授权',
            keepAlive: false
        },
        component: resolve => require(['@/views/newSaas/zc_authorization.vue'], resolve),
    },
    {
        path: '/ba_pay',
        name: 'ba_pay',
        meta: {
            title: '小程序认证费用',
            keepAlive: false
        },
        component: resolve => require(['@/views/newSaas/ba_pay.vue'], resolve),
    },
    {
        path: '/vip_level',
        name: 'vip_level',
        meta: {
            title: '会员等级',
            keepAlive: false
        },
        component: resolve => require(['@/views/user/vip_level.vue'], resolve),
    },
    {
        path: '/vip_benefit',
        name: 'vip_benefit',
        meta: {
            title: '会员权益',
            keepAlive: false
        },
        component: resolve => require(['@/views/user/vip_benefit.vue'], resolve),
    },
    {
        path: '/vip_card',
        name: 'vip_card',
        meta: {
            title: '用户会员卡',
            keepAlive: false
        },
        component: resolve => require(['@/views/user/vip_card.vue'], resolve),
    },
    {
        path: '/official_class',
        name: 'official_class',
        meta: {
            title: '商品分类',
            keepAlive: false
        },
        component: resolve => require(['@/views/official/official_class.vue'], resolve),
    },
    {
        path: '/official_goods',
        name: 'official_goods',
        meta: {
            title: '商品管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/official/official_goods.vue'], resolve),
    },
    {
        path: '/vip_growth_log',
        name: 'vip_growth_log',
        meta: {
            title: '会员成长值明细',
            keepAlive: false
        },
        component: resolve => require(['@/views/user/vip_growth_log.vue'], resolve),
    },
    {
        path: '/case',
        name: 'case',
        meta: {
            title: '行业案例',
            keepAlive: false
        },
        component: resolve => require(['@/views/user/case.vue'], resolve),
    },
    {
        path: '/dy_shop',
        name: 'dy_shop',
        meta: {
            title: '抖音来客门店',
            keepAlive: false
        },
        component: resolve => require(['@/views/douyin/dy_shop.vue'], resolve),
    },
    {
        path: '/merchantApply',
        name: 'merchantApply',
        meta: {
            title: '微信支付进件',
            keepAlive: false
        },
        component: resolve => require(['@/views/apply/merchantApply.vue'], resolve),
    },
    {
        path: '/customservice',
        name: 'customservice',
        meta: {
            title: '小程序客服',
            keepAlive: false
        },
        component: resolve => require(['@/views/newSaas/customservice.vue'], resolve),
    },
  ]
},
{
  path: '/login',
  name: 'Login',
  meta: {
    title: '登录',
    keepAlive: false
  },
  components: {
    blank: resolve => require(['@/views/login/Login.vue'], resolve)
  }
},
{
  path: '/dyAuth',
  name: 'dyAuth',
  meta: {
    title: '抖音授权',
    keepAlive: false
  },
  components: {
    blank: resolve => require(['@/views/dyAuth/auth.vue'], resolve)
  }
},
{
  path: '/*',
  name: 'NotFound',
  meta: {
    title: '404',
    keepAlive: true
  },
  components: {
    blank: resolve => require(['@/views/error/404.vue'], resolve)
  }
}
]

export default new Router({
  routes: RouteList
})
